import React from "react";

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_solidarity-hub-15/artifacts/133hdsq6_425270B1-F179-4AB5-AD31-7D104533D284.jpeg";

export default function Logo({ size = 40, className = "" }) {
  return (
    <img
      src={LOGO_URL}
      alt="MABW – Make A Better World"
      width={size}
      height={size}
      className={`rounded-xl object-cover ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
